import React from "react";
import FilterTitle from "../Common/FilterTitle";
import InputForm from "../Common/InputForm";
import InputFormDouble from "../Common/InputFormDouble";

const MilageAndYear = () => {
  return (
    <div className="border-b border-darkGreen border-opacity-40 px-2 py-8">
      <FilterTitle title="Choose milage and year" />
      <InputFormDouble title={"Milage"} />
      <InputForm title={"Year"} />
    </div>
  );
};

export default MilageAndYear;
